import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
let FolderCapacityModelImpl = class FolderCapacityModelImpl {
    constructor() {
        this._folderCapacity = proxy(null);
    }
    get folderCapacity() {
        return this._folderCapacity.value;
    }
    updateFolderCapacity(folderCapacity) {
        this._folderCapacity.value = folderCapacity;
    }
    subscribeFolderCapacity(callback) {
        const dispose = subscribe(() => this._folderCapacity.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
FolderCapacityModelImpl = __decorate([
    injectable()
], FolderCapacityModelImpl);
export { FolderCapacityModelImpl };
